module.exports = __webpack_public_path__ + "static/media/white-youtube.a29a2e7a.svg";